import { useQuery } from 'react-query';

import { getKioskList } from '@/api/user';

function useGetKioskList() {
  return useQuery('kioskList', () => getKioskList(), {
    retry: false,
  });
}

export default useGetKioskList;
